import Api from '../../base/api.typings';
import axiosConfiguration from '../../base/axios-configuration';

class ChamadoService {
    async registrarChamado(command: any): Promise<string> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/Chamado/RegistrarChamado', command).then(r => r.data);
    }

    async listarChamados(query: Api.App.Server.Chamado.ListarChamados.Query): Promise<Api.App.Server.Chamado.ListarChamados.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Chamado/ListarChamados', { params: query }).then(e => e.data);
    }

    async detalharChamado(query: Api.App.Server.Chamado.DetalharChamado.Query): Promise<Api.App.Server.Chamado.DetalharChamado.Dto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Chamado/DetalharChamado', { params: query }).then(e => e.data);
    }

    async editarChamado(command: Api.App.Server.Chamado.EditarChamado.Command) {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().put('/api/Chamado/EditarChamado', command);
    }

    async registrarInteracao(command: any): Promise<string> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/Chamado/RegistrarInteracao', command).then(r => r.data);
    }

    async cadastrarChamadoRecorrente(command: any) {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/Chamado/CadastrarChamadoRecorrente', command);
    }

    async inserirChamadoAutomatico(command: any) {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/Chamado/inserirChamadoAutomatico', command);
    }
}

export default new ChamadoService();